import { render, staticRenderFns } from "./createPaciente.vue?vue&type=template&id=e6b8724e&scoped=true"
import script from "./createPaciente.vue?vue&type=script&lang=js"
export * from "./createPaciente.vue?vue&type=script&lang=js"
import style0 from "./createPaciente.vue?vue&type=style&index=0&id=e6b8724e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b8724e",
  null
  
)

export default component.exports